export enum EventTypes {
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
  }